// Única definición de "layout mobile" vs "layout desktop" para toda la app.
//
//  - Mobile: pantallas de hasta 991px de ancho (teléfonos y tablets en vertical
//    como iPad mini/Air/Pro 11") MÁS cualquier pantalla en vertical de hasta
//    1100px (iPad Pro 12.9"/13" en vertical = 1024-1032px de ancho).
//  - Desktop: todo lo demás (laptops, monitores y tablets en horizontal).
//
// Una tablet en vertical se ve igual que el teléfono; una tablet en horizontal
// se ve igual que desktop. Las dos constantes son complementarias exactas (una
// pantalla siempre cae en una y solo una), así que se pueden mezclar en CSS
// sin que se pisen. En CSS plano no hay variables para @media, por eso las
// hojas .css repiten estas mismas condiciones literales.
export const MOBILE_MAX_WIDTH = 991;
export const PORTRAIT_MOBILE_MAX_WIDTH = 1100;

export const MOBILE_MEDIA = `(max-width: ${MOBILE_MAX_WIDTH}px), (max-width: ${PORTRAIT_MOBILE_MAX_WIDTH}px) and (orientation: portrait)`;
export const DESKTOP_MEDIA = `(min-width: ${PORTRAIT_MOBILE_MAX_WIDTH + 1}px), (min-width: ${MOBILE_MAX_WIDTH + 1}px) and (orientation: landscape)`;
